module.exports = __webpack_public_path__ + "img/family.e6d47b64.png";